import { Pipe, PipeTransform } from '@angular/core';
import { prefixUrl } from '../utils/url.util';

@Pipe({
  name: 'prefixUrl',
})
export class PrefixUrlPipe implements PipeTransform {
  transform(logicalPath: string | undefined | null): string {
    return prefixUrl(logicalPath);
  }
}
